import { render } from "./CoursesComponent.vue?vue&type=template&id=243a8237&scoped=true"
import script from "./CoursesComponent.vue?vue&type=script&lang=js"
export * from "./CoursesComponent.vue?vue&type=script&lang=js"

import "./CoursesComponent.vue?vue&type=style&index=0&id=243a8237&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243a8237"]])

export default __exports__